'use client';

import { useCallback, useEffect } from 'react';
import { useGeminiVoice } from '@hooks/voice/useGeminiVoice';
import type { GeminiVoiceOptions } from '@hooks/voice/useGeminiVoice';
import GeminiVoiceCard from '@components/features/voice/GeminiVoiceCard';

interface GeminiVoiceWidgetProps extends GeminiVoiceOptions {
  autoStart?: boolean;
  onClose?: () => void;
}

export default function GeminiVoiceWidget({
  agentName,
  promptParts,
  firstMessage,
  maxRetries,
  autoStart = true,
  onClose,
}: GeminiVoiceWidgetProps) {
  const { status, error, start, stop } = useGeminiVoice({
    agentName,
    promptParts,
    firstMessage,
    maxRetries,
  });

  useEffect(() => {
    if (autoStart) {
      void start();
    }
    return () => { stop(); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleClose = useCallback(() => {
    stop();
    onClose?.();
  }, [stop, onClose]);

  return <GeminiVoiceCard status={status} error={error} onClose={handleClose} />;
}
